import { render } from "./HeroSlider.vue?vue&type=template&id=a4ba8b12&scoped=true"
import script from "./HeroSlider.vue?vue&type=script&lang=js"
export * from "./HeroSlider.vue?vue&type=script&lang=js"

import "./HeroSlider.vue?vue&type=style&index=0&id=a4ba8b12&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/topik-vue/topik-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4ba8b12"]])

export default __exports__